import React, { useCallback, useState } from 'react';
import { InputCidade, InputMaskCep, InputText } from '~/components/NovosInputs';
import { useEmissaoNFE } from '../../EmissaoNFEContext';
import { toast } from 'react-toastify';
import { formatCep } from '~/utils/functions';
import axios from 'axios';
import {
  ContainerDadosEntrega,
  FieldDadosEntrega,
  GridDadosEntrega,
} from './styles';

export const DadosEntrega: React.FC = () => {
  const [loading, setLoading] = useState({ cep: false });
  const [cidadeBuscar, setCidadeBuscar] = useState<
    { cidade: string; uf: string } | undefined
  >(undefined);

  const { formDadosEntrega, codCidadeEntregaRetriever, isUpdate } =
    useEmissaoNFE();

  const {
    control,
    getValues,
    register,
    setValue,
    clearErrors,
    formState: { errors },
  } = formDadosEntrega;

  const searchCep = useCallback(async () => {
    if (isUpdate) return;

    const numCep = getValues('num_cep_entrega');

    if (!numCep || numCep?.replace(/[^\d]/g, '') === '') {
      toast.warning('Nenhum CEP válido informado');
      return;
    }

    try {
      setLoading({ cep: true });
      const { data } = await axios.get(
        `https://viacep.com.br/ws/${numCep?.replace(/[^\d]/g, '')}/json/`,
      );

      if ('erro' in data) {
        toast.warning(`CEP: ${formatCep(numCep)}, não enconrtado`);
        setCidadeBuscar(undefined);
        return;
      }

      setValue('des_logradouro_entrega', (data.logradouro ?? '').toUpperCase());
      setValue('des_bairro_entrega', (data.bairro ?? '').toUpperCase());
      setCidadeBuscar({
        cidade: (data.localidade ?? '').toUpperCase(),
        uf: (data.uf ?? '').toUpperCase(),
      });
      clearErrors(['num_cep_entrega', 'cod_cidade_entrega']);
      if (data?.logradouro) clearErrors('des_logradouro_entrega');
      if (data?.bairro) clearErrors('des_bairro_entrega');
    } catch (error) {
      setCidadeBuscar(undefined);
      toast.warning(`CEP: ${formatCep(numCep)}, não enconrtado`);
    } finally {
      setLoading({ cep: false });
    }
  }, [clearErrors, getValues, isUpdate, setValue]);

  return (
    <ContainerDadosEntrega>
      <GridDadosEntrega>
        <FieldDadosEntrega area="cep">
          <InputMaskCep
            label="CEP *"
            name="num_cep_entrega"
            isError={!!errors.num_cep_entrega}
            control={control}
            hasButton={!isUpdate}
            loadingIcon={loading.cep}
            clickedButton={async () => {
              await searchCep();
            }}
            disabled={isUpdate}
          />
        </FieldDadosEntrega>
        <FieldDadosEntrega area="logradouro">
          <InputText
            label="Logradouro *"
            placeholder="Informe o logradouro"
            name="des_logradouro_entrega"
            isError={!!errors.des_logradouro_entrega}
            register={register}
            control={control}
            maxLength={100}
            toLowerCase={false}
            caseInput="upper"
            onInput={(ev: any) => {
              setValue('des_logradouro_entrega', ev.target.value);
              clearErrors('des_logradouro_entrega');
            }}
            disabled={isUpdate}
            isDisabled={isUpdate}
          />
        </FieldDadosEntrega>
        <FieldDadosEntrega area="numero">
          <InputText
            label="Número *"
            placeholder="Informe o número"
            name="num_endereco_entrega"
            isError={!!errors.num_endereco_entrega}
            register={register}
            control={control}
            maxLength={15}
            toLowerCase={false}
            caseInput="upper"
            onInput={(ev: any) => {
              setValue('num_endereco_entrega', ev.target.value);
              clearErrors('num_endereco_entrega');
            }}
            disabled={isUpdate}
            isDisabled={isUpdate}
          />
        </FieldDadosEntrega>
        <FieldDadosEntrega area="bairro">
          <InputText
            label="Bairro *"
            placeholder="Informe o bairro"
            name="des_bairro_entrega"
            isError={!!errors.des_bairro_entrega}
            register={register}
            control={control}
            maxLength={50}
            toLowerCase={false}
            caseInput="upper"
            onInput={(ev: any) => {
              setValue('des_bairro_entrega', ev.target.value);
              clearErrors('des_bairro_entrega');
            }}
            disabled={isUpdate}
            isDisabled={isUpdate}
          />
        </FieldDadosEntrega>
        <FieldDadosEntrega area="complemento">
          <InputText
            label="Complemento"
            placeholder="Informe o complemento"
            name="des_complemento_entrega"
            isError={false}
            register={register}
            control={control}
            maxLength={50}
            toLowerCase={false}
            caseInput="upper"
            onInput={(ev: any) => {
              setValue('des_complemento_entrega', ev.target.value);
            }}
            disabled={isUpdate}
            isDisabled={isUpdate}
          />
        </FieldDadosEntrega>
        <FieldDadosEntrega area="cidade">
          <InputCidade
            maxLength={50}
            setValue={setValue}
            label="Cidade *"
            placeholder="Selecione a cidade"
            name="cod_cidade_entrega"
            cidadeABuscar={cidadeBuscar}
            register={register}
            clearCampo={false}
            isError={!!errors.cod_cidade_entrega}
            control={control}
            changeSelected={(selected) => {
              setValue('cod_cidade_entrega', selected);
              clearErrors('cod_cidade_entrega');
            }}
            codCidadeRetriever={codCidadeEntregaRetriever}
            disabled={isUpdate}
            isDisabled={isUpdate}
          />
        </FieldDadosEntrega>
      </GridDadosEntrega>
    </ContainerDadosEntrega>
  );
};
